import {
	CalendarDays,
	CalendarRange,
	ChevronLeft,
	ChevronRight,
	LayoutList,
	Maximize2,
	Minimize2,
	Palette,
	Printer,
	TriangleAlert,
} from "lucide-react";
import type { ReactNode } from "react";

import { Button } from "@/components/ui/button";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import { ViewToggle, type ViewToggleOption } from "@/components/view-toggle";
import type { ColorScheme } from "../../utils/colors.ts";
import type { TimeScale } from "../../utils/scale.ts";

const SCALE_OPTIONS: ViewToggleOption<TimeScale>[] = [
	{ value: "days", label: "Dias", icon: CalendarDays },
	{ value: "weeks", label: "Semanas", icon: CalendarRange },
];

export function GanttToolbar({
	scale,
	onScale,
	scheme,
	onScheme,
	legend,
	onLegend,
	delayedCount,
	notesButton,
	fullscreen,
	onFullscreen,
	onPrint,
	onPrevious,
	onNext,
	onToday,
}: {
	scale: TimeScale;
	onScale: (scale: TimeScale) => void;
	scheme: ColorScheme;
	onScheme: (scheme: ColorScheme) => void;
	legend: boolean;
	onLegend: (legend: boolean) => void;
	delayedCount: number;
	notesButton?: ReactNode;
	fullscreen: boolean;
	onFullscreen: () => void;
	onPrint: () => void;
	onPrevious: () => void;
	onNext: () => void;
	onToday: () => void;
}) {
	return (
		<div className="schedule-gantt__toolbar">
			<ViewToggle options={SCALE_OPTIONS} value={scale} onChange={onScale} />
			{delayedCount > 0 && (
				<span className="schedule-gantt__delayed-count">
					<TriangleAlert />
					{delayedCount === 1 ? "1 atrasada" : `${delayedCount} atrasadas`}
				</span>
			)}
			<span className="schedule-gantt__toolbar-spacer" />
			{notesButton}
			<Select
				value={scheme}
				onValueChange={(value) => onScheme(value as ColorScheme)}
			>
				<SelectTrigger
					size="sm"
					aria-label="Cores"
					className="schedule-gantt__scheme"
				>
					<Palette />
					<SelectValue />
				</SelectTrigger>
				<SelectContent>
					<SelectItem value="status">Por situação</SelectItem>
					<SelectItem value="hierarchy">Por etapa pai</SelectItem>
				</SelectContent>
			</Select>
			<Button
				type="button"
				variant="outline"
				size="sm"
				aria-pressed={legend}
				onClick={() => onLegend(!legend)}
			>
				<LayoutList />
				Legenda
			</Button>
			<Button type="button" variant="outline" size="sm" onClick={onFullscreen}>
				{fullscreen ? <Minimize2 /> : <Maximize2 />}
				{fullscreen ? "Sair da tela cheia" : "Tela cheia"}
			</Button>
			<Button type="button" variant="outline" size="sm" onClick={onPrint}>
				<Printer />
				Imprimir cronograma
			</Button>
			<span className="schedule-gantt__toolbar-group">
				<Button
					type="button"
					variant="ghost"
					size="icon"
					aria-label="Mês anterior"
					onClick={onPrevious}
				>
					<ChevronLeft />
				</Button>
				<Button type="button" variant="outline" size="sm" onClick={onToday}>
					Hoje
				</Button>
				<Button
					type="button"
					variant="ghost"
					size="icon"
					aria-label="Próximo mês"
					onClick={onNext}
				>
					<ChevronRight />
				</Button>
			</span>
		</div>
	);
}
